import script from "./ExerciseListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExerciseListView.vue?vue&type=script&setup=true&lang=ts"

import "./ExerciseListView.vue?vue&type=style&index=0&id=c11332d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c11332d0"]])

export default __exports__